import { Card, CardContent, CardHeader, CardTitle, ScrollArea } from '@ibsys/kit';
import { FC, ReactNode } from 'react';
import { cn } from '@/shared/lib';
import { DASHBOARD_BLOCK_MAX_HEIGHT_CLASS } from '../utils';

type Props = {
  title: string;
  /**
   * Прокручивать содержимое внутри карточки при переполнении. Отключается у блоков со своей
   * прокруткой (таблицы): вложенная прокрутка внутри прокрутки неуправляема мышью.
   */
  scrollable?: boolean;
  children: ReactNode;
};

/**
 * Карточка диаграммы пользовательского дашборда: заголовок и содержимое, ограниченное отведённой
 * диаграмме высотой и общим потолком высоты блоков дашборда.
 *
 * Не поместившееся содержимое прокручивается внутри самой диаграммы — по каждой стороне отдельно
 * и только там, где места не хватило: узкой доле ширины широкий тип отдаётся прокруткой, а не
 * сжатием, зато вставшая целиком диаграмма полос не показывает вовсе.
 *
 * Содержимое со своей прокруткой прокручивается и по месту, которое оно за собой держит: у
 * наименьших заданных высот таблица не сжимается до одной шапки, а выходит за отведённое ей место,
 * и до её строк добираются прокруткой содержимого диаграммы.
 */
export const ChartCardShell: FC<Props> = ({ title, scrollable = true, children }) => (
  <Card className="min-h-0 overflow-hidden">
    <CardHeader className="shrink-0">
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent className={cn('min-h-0 flex-1', !scrollable && 'overflow-y-auto overflow-x-hidden')}>
      {scrollable ? (
        <ScrollArea className={cn('h-full', DASHBOARD_BLOCK_MAX_HEIGHT_CLASS)}>{children}</ScrollArea>
      ) : (
        children
      )}
    </CardContent>
  </Card>
);
